/**
 * Phase C — scroll fade-in for section heads + product rails.
 * One-shot Intersection Observer; respects prefers-reduced-motion.
 */
(function (window, document) {
  'use strict';

  var SELECTORS = [
    '.wmn-section-head',
    '.featured-collection-section .product-list',
    '.featured-collection-section .homepage-product-slider',
    '.featured-collection-section .slider-gallery',
    '#wmn-for-you-grid',
    '.wmn-editorial__articles',
    '.wmn-editorial__staff',
    '.js-recently-viewed .product-list',
    '.js-rv-grid'
  ].join(',');

  var observer = null;
  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function targets(root) {
    var scope = root && root.querySelectorAll ? root : document;
    return Array.prototype.slice.call(scope.querySelectorAll(SELECTORS));
  }

  function reveal(el) {
    el.classList.add('is-inview');
    if (observer) observer.unobserve(el);
  }

  function prepare(el) {
    if (!el || el.classList.contains('wmn-reveal')) return;
    el.classList.add('wmn-reveal');
  }

  function observeAll(root) {
    var nodes = targets(root);
    if (!nodes.length) return;

    if (reduced) {
      nodes.forEach(function (el) {
        prepare(el);
        reveal(el);
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        prepare(el);
        reveal(el);
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              reveal(entry.target);
            }
          });
        },
        {
          root: null,
          // Reveal slightly before enter — above-fold mounts as visible immediately.
          rootMargin: '12% 0px 12% 0px',
          threshold: 0.01
        }
      );
    }

    nodes.forEach(function (el) {
      prepare(el);
      if (el.classList.contains('is-inview')) return;
      // Sync above-fold reveal — no waiting for observer tick (felt like a blank page).
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < vh * 1.05 && rect.bottom > -40) {
        reveal(el);
        return;
      }
      observer.observe(el);
    });
  }

  function watchLateRails() {
    if (!('MutationObserver' in window)) return;
    var late = document.querySelectorAll('#wmn-for-you, .js-recently-viewed');
    if (!late.length) return;

    var timer = null;
    var mo = new MutationObserver(function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        observeAll(document);
      }, 80);
    });

    Array.prototype.forEach.call(late, function (el) {
      mo.observe(el, {
        attributes: true,
        attributeFilter: ['hidden', 'class'],
        childList: true,
        subtree: true
      });
    });
  }

  function init(root) {
    document.documentElement.classList.add('wmn-motion');
    observeAll(root || document);
    if (!root || root === document) {
      watchLateRails();
    }
  }

  window.wmnMotion = {
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})(window, document);
